import React, { createContext, useState, useContext, useEffect } from 'react'
import { authService } from '../services/authService'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [token, setToken] = useState(localStorage.getItem('token'))
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkAuth = async () => {
      const storedToken = localStorage.getItem('token')
      const storedUser = localStorage.getItem('user')
      
      console.log('🔐 Checking authentication...', { storedToken: !!storedToken, storedUser: !!storedUser })
      
      if (storedToken && storedUser) {
        try {
          setToken(storedToken)
          setUser(JSON.parse(storedUser))
          
          // Verify the token is still valid by calling /auth/me
          console.log('🔄 Verifying token validity...')
          const userData = await authService.getCurrentUser()
          console.log('✅ Token is valid, user:', userData)
          setUser(userData)
          // Update stored user data with fresh data from server
          localStorage.setItem('user', JSON.stringify(userData))
        } catch (error) {
          console.error('❌ Token validation failed:', error)
          // Token is invalid, clear storage
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          setToken(null)
          setUser(null)
        }
      } else {
        console.log('ℹ️ No stored authentication found')
      }
      setLoading(false)
    }

    checkAuth()
  }, [])

  const login = async (newToken, userData) => {
    console.log('🔐 Logging in user...', { token: newToken?.substring(0, 20) + '...', user: userData })
    
    try {
      // Store token and user data
      localStorage.setItem('token', newToken)
      localStorage.setItem('user', JSON.stringify(userData))
      
      setToken(newToken)
      setUser(userData)
      
      console.log('✅ Login successful')
    } catch (error) {
      console.error('❌ Login failed:', error)
      throw error
    }
  }

  const logout = async () => {
    console.log('🚪 Logging out user...')
    
    try {
      await authService.logout()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      // Clear local storage and state
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      setToken(null)
      setUser(null)
      console.log('✅ Logout completed')
    }
  }

  const value = {
    user,
    token,
    login,
    logout,
    loading
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
